import legacy from './legacy-data.json';
export const company = {
  name: 'Audit Vector',
  email: 'info@auditvector.kz',
  address: 'г. Астана, ЖК Тельман, ул. Аккемер 12/3',
  license: '№ 24032816',
  licenseDate: '13 ноября 2024',
  registration: '09 июня 2022',
  membership: 'Союз аудиторов Казахстана',
  certificate: '№ 0158',
  description:
    'Независимая инвентаризация имущества, проверка ТМЗ и аудит финансовой отчётности на объектах с распределённой структурой и сложной инфраструктурой по всей территории Казахстана.',
};
export const services = legacy.services;
export const cases = legacy.cases;
export const competencies = legacy.comp;
export const clients = legacy.clients;
export const principles = legacy.princ;
export const navigation = [
  { label: 'Услуги', href: '/services/' },
  { label: 'О компании', href: '/about/' },
  { label: 'Проекты', href: '/cases/' },
  { label: 'Контакты', href: '/contact/' },
];
export const process = [
  {
    name: 'Планирование',
    title: 'Начинаем с понимания вашей задачи',
    description:
      'Определяем объекты проверки, объём работ и особенности учёта. Согласовываем порядок инвентаризации, состав команды и сроки проекта.',
    steps: [
      'Задача и объекты проверки',
      'Объём и методика',
      'Команда и график',
      'Согласованный план',
    ],
    result: 'План проверки',
  },
  {
    name: 'Проверка',
    title: 'Проверяем факты. Сверяем данные.',
    description:
      'Проводим независимую проверку на площадках, сверяем фактическое наличие активов с данными бухгалтерского учёта. Фиксируем расхождения и анализируем их причины.',
    steps: [
      'Работа на площадках',
      'Проверка наличия активов',
      'Сверка с данными учёта',
      'Анализ расхождений',
    ],
    result: 'Проверенные данные',
  },
  {
    name: 'Отчёт',
    title: 'Превращаем результаты в понятные решения',
    description:
      'Готовим структурированный итоговый отчёт с результатами проверки и рекомендациями. Представляем выводы так, чтобы ими могли пользоваться и бухгалтерия, и руководство.',
    steps: [
      'Результаты проверки',
      'Структурированный отчёт',
      'Практические рекомендации',
      'Презентация результатов',
    ],
    result: 'Итоговый отчёт',
  },
];
export const faq = [
  {
    q: 'С какими задачами можно обратиться?',
    a: 'Мы проводим аудит финансовой отчётности, инвентаризацию товарно-материальных запасов и основных средств, а также готовим аналитические отчёты по результатам проверки.',
  },
  {
    q: 'Вы работаете только в Астане?',
    a: 'Компания зарегистрирована в Астане. Работаем с предприятиями и распределёнными площадками по всей территории Казахстана.',
  },
  {
    q: 'Есть ли опыт на крупных промышленных объектах?',
    a: 'В портфеле — инвентаризация ТМЗ для KATCO в 2022–2024 годах и проверка активов Уральского завода «Зенит». Есть опыт работы с крупными объёмами запасов и сложной инфраструктурой.',
  },
  {
    q: 'Как определяется стоимость и срок проверки?',
    a: 'Объём работ зависит от задачи, количества объектов и особенностей учёта. Чтобы получить коммерческое предложение, отправьте описание задачи, расположение площадок и ориентировочные сроки.',
  },
  {
    q: 'Какие документы подтверждают статус компании?',
    a: 'Государственная лицензия № 24032816 выдана 13 ноября 2024 года. Компания является членом Профессиональной аудиторской организации «Союз аудиторов Казахстана» с 2022 года; свидетельство № 0158.',
  },
];
